import { GearIcon, ICON_BG_COLOR_MAP } from '@/components/icons/Gear';
import { GEAR } from '@/utils/constants';
import AssetImage from '@/components/ui/AssetImage';
import { ToneAndChildren } from '@/utils/helpers';

const ToneImage = ({ tone }: { tone: ToneAndChildren }) => {
  const imageUrl = tone.images?.[0];
  return (
    <>
      <div className="flex sm:hidden w-full h-full justify-center">
        {imageUrl ? (
          <div className="rounded-lg w-[256px] h-[256px] relative">
            <AssetImage
              src={imageUrl}
              alt={'TONE3000'}
              fill
              priority
              className="object-cover rounded-lg"
              sizes="(max-width: 640px) 100vw, 352px"
            />
          </div>
        ) : (
          <div
            className="rounded-lg w-[256px] h-[256px] flex items-center justify-center"
            style={{ backgroundColor: ICON_BG_COLOR_MAP[tone.gear as GEAR] }}
          >
            <GearIcon size={100} gear={tone.gear as GEAR} isColor={true} />
          </div>
        )}
      </div>
      <div className="hidden sm:block">
        {imageUrl ? (
          <div className="rounded-lg flex flex-shrink-0 sm:w-[352px] sm:h-[352px] md:w-[200px] md:h-[200px] lg:w-[352px] lg:h-[352px] relative overflow-hidden">
            <AssetImage
              src={imageUrl}
              alt={'TONE3000'}
              fill
              priority
              className="object-cover"
              sizes="352px"
            />
          </div>
        ) : (
          <div
            className="rounded-lg flex flex-shrink-0 sm:w-[352px] sm:h-[352px] md:w-[200px] md:h-[200px] lg:w-[352px] lg:h-[352px] items-center justify-center"
            style={{ backgroundColor: ICON_BG_COLOR_MAP[tone.gear as GEAR] }}
          >
            <GearIcon size={128} gear={tone.gear as GEAR} isColor={true} />
          </div>
        )}
      </div>
    </>
  );
};

export default ToneImage;
